module.exports = __webpack_public_path__ + "svg/app-engine.5cd1fd.svg";